<!-- Only Next Button (First Page) -->
<div *ngIf="currentIndex === 0 && totalPages.length > 1 && totalPages[currentIndex + 1]"
    class="w-full p-2 flex items-center justify-end">
    <button (click)="$event.preventDefault(); goToNext()" [disabled]="!hasNext()"
        class="shadow-custom-2 px-8 py-1 flex flex-row items-center gap-2 text-lg font-light text-white oswald-font bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 rounded-md btn-shadow hover:bg-gradient-to-b hover:from-nside-gray-100 hover:to-nside-gray-200 cursor-pointer">
        {{ totalPages[currentIndex + 1].title }}
        <lucide-icon [name]="icons.ChevronRight" class=""></lucide-icon>
    </button>
</div>

<!-- Prev and Next Buttons (Middle Pages) -->
<div *ngIf="currentIndex > 0 && currentIndex < totalPages.length - 1 && totalPages[currentIndex + 1] && totalPages[currentIndex - 1]"
    class="w-full p-2 flex items-center justify-between">
    <button (click)="$event.preventDefault(); goToPrevious()" [disabled]="!hasPrevious()"
        class="shadow-custom-2 px-8 py-1 flex flex-row items-center gap-2 text-lg font-light text-white oswald-font bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 rounded-md btn-shadow hover:bg-gradient-to-b hover:from-nside-gray-100 hover:to-nside-gray-200 cursor-pointer">
        <lucide-icon [name]="icons.ChevronLeft" class=""></lucide-icon>
        {{ totalPages[currentIndex - 1].title }}
    </button>
    <button (click)="$event.preventDefault(); goToNext()" [disabled]="!hasNext()"
        class="shadow-custom-2 px-8 py-1 flex flex-row items-center gap-2 text-lg font-light text-white oswald-font bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 rounded-md btn-shadow hover:bg-gradient-to-b hover:from-nside-gray-100 hover:to-nside-gray-200 cursor-pointer">
        {{ totalPages[currentIndex + 1].title }}
        <lucide-icon [name]="icons.ChevronRight" class=""></lucide-icon>
    </button>
</div>

<!-- Only Previous Button (Last Page) -->
<div *ngIf="currentIndex === totalPages.length - 1 && totalPages[currentIndex - 1]"
    class="w-full p-2 flex items-center justify-start">
    <button (click)="$event.preventDefault(); goToPrevious()" [disabled]="!hasPrevious()"
        class="shadow-custom-2 px-8 py-1 flex flex-row items-center gap-2 text-lg font-light text-white oswald-font bg-gradient-to-b from-nside-gray-300 to-nside-gray-400 rounded-md btn-shadow hover:bg-gradient-to-b hover:from-nside-gray-100 hover:to-nside-gray-200 cursor-pointer">
        <lucide-icon [name]="icons.ChevronLeft" class=""></lucide-icon>
        {{ totalPages[currentIndex - 1].title }}
    </button>
</div>